__turbopack_context__.v({
  "app-wrapper": "ClientLayout-module-scss-module__Ph5ofG__app-wrapper",
  "notice-banner": "ClientLayout-module-scss-module__Ph5ofG__notice-banner",
});
